(function(Slidebar) {
    'use strict';

    // Rebuild of the slidebar, with the and back and next buttons.

    // Current slide variable.
    Slidebar.current = 1;

    // The elements of the slider.
    Slidebar.elements = {
        slider: '#slide_bar',
        next: '.button_next',
        prev: '.button_previous',
        container: '.mslider .container'
    };

    // I think it is the width of a child element.
    Slidebar.childWidth = 194;

    // Start the slider, start with the current, and add the event handlers for the buttons.
    Slidebar.init = function() {
        Slidebar.to(Slidebar.current);

        $(Slidebar.elements.next).on('click', function() {
            Slidebar.to(Slidebar.current + 1);
        });

        $(Slidebar.elements.prev).on('click', function() {
            Slidebar.to(Slidebar.current - 1);
        });
    };

    /**
     * Slide to a position, and update the next and prev buttons.
     *
     * @param int slide
     */
    Slidebar.to = function(slide) {
        var stopAt = 3;
        var childs = $(Slidebar.elements.slider).children().length;
        var totalWidth = (childs * Slidebar.childWidth);
        var withContainer = $(Slidebar.elements.container).width();
        var visible = (totalWidth - withContainer);

        if (visible > 0) {
            stopAt = Math.round(visible / Slidebar.childWidth) + 2;
        }

        if (stopAt >= slide && slide >= 1) {
            $(Slidebar.elements.slider).stop().animate({
                marginLeft: ((slide - 1) * Slidebar.childWidth) * -1
            }, 800);

            Slidebar.current = slide;
        }

        $(Slidebar.elements.prev + ', ' + Slidebar.elements.next).show();

        if (Slidebar.current <= 1) {
            $(Slidebar.elements.prev).hide();
        }

        if (Slidebar.current >= stopAt) {
            $(Slidebar.elements.next).hide();
        }
    };

    // Create the handler.
    Way2web.handlers.slidebar = Slidebar.init;
})(window.Way2web.Slidebar = window.Way2web.Slidebar || {});
